<div class="flex">
    <span class="ham-icon icon">
        <i class="exclamation-outline-icon"></i>
    </span>
    <span>
        {{ 'aumico_annual_report_cashflow_unsaved_changes' | i18next }}
    </span>
</div>
